/* eslint-disable import/extensions */
/* eslint-disable quote-props */
import { api } from '@/services';
import cotacaoSchema from '@/components/simulacao/validation/cotacaoSchema.js';
import realizarSimulacaoSchema from '@/components/simulacao/validation/realizarSimulacaoSchema.js';
import realizarSimulacaoContaOrdemSchema from '@/components/simulacao/validation/realizarSimulacaoContaOrdemSchema.js';
import * as XLSX from 'xlsx';
import { AxiosError } from 'axios';

export default {
  async fetchCotacao({ commit, dispatch }, id) {
    dispatch('toggleLoading', true, { root: true });

    const response = await api.get(`/simulacao/${id}`);

    let { data: cotacao } = response;

    if (!cotacao.isCotacaoFeita) {
      const cotacaoComValoresPadrao = await dispatch('setarValoresPadrao', { ...cotacao });

      cotacao = cotacaoComValoresPadrao;
    }

    commit('SET_COTACAO', cotacao);
    dispatch('toggleLoading', false, { root: true });

    return cotacao;
  },
  async fetchCotacoes({ commit, dispatch }, filtros) {
    const params = new URLSearchParams();

    for (const key of Object.keys(filtros)) {
      if (filtros[key]) {
        params.append(key, filtros[key]);
      }
    }

    dispatch('toggleLoading', true, { root: true });

    const response = await api.get('/simulacao/listar', { params });

    const { data: cotacoes } = response;

    commit('SET_COTACOES', cotacoes.data);
    commit('paginacao/SET_PAGINADOR', cotacoes, { root: true });

    dispatch('toggleLoading', false, { root: true });
  },
  // eslint-disable-next-line consistent-return
  async solicitarCotacao({ dispatch }, payload) {
    try {
      const cotacao = await cotacaoSchema.validate(payload, {
        abortEarly: false,
        stripUnknown: true,
      });

      const {
        produtos,
        ...cotacaoObj
      } = cotacao;

      const formData = new FormData();

      // mudar essa nojera aqui, formdata é horroroso
      Object.entries(cotacaoObj).forEach(([key, value]) => {
        formData.append(key, value);
      });

      if (Array.isArray(produtos) && produtos.length) {
        Object.entries(produtos).forEach(([, value], i) => {
          Object.entries(value).forEach(([key, item]) => {
            formData.append(`produtos[${i}].${key}`, item);
          });
        });
      }

      dispatch('toggleLoading', true, { root: true });

      await api.post('/simulacao/solicitar/', formData, {
        headers: {
          'Content-Type': 'multiform/form-data',
        },
      });

      dispatch('toggleLoading', false, { root: true });
      dispatch('fetchCotacoes', { page: 1, perPage: 20 });
    } catch (e) {
      console.error(e);

      dispatch('toggleLoading', false, { root: true });

      if (e instanceof AxiosError) {
        return e;
      }

      return e.inner;
    }
  },
  // eslint-disable-next-line consistent-return
  async realizarSimulacao({ dispatch }, payload) {
    try {
      const { _id } = payload;

      let simulacao = null;

      if (payload.classificacao === 'Encomenda') {
        simulacao = await realizarSimulacaoSchema.validate(payload, {
          abortEarly: false,
          stripUnknown: false,
        });
      } else {
        simulacao = await realizarSimulacaoContaOrdemSchema.validate(payload, {
          abortEarly: false,
          stripUnknown: false,
        });
      }

      dispatch('toggleLoading', true, { root: true });

      await api.put(`/simulacao/simular/${_id}`, simulacao);
      await dispatch('fetchCotacao', _id);

      dispatch('toggleLoading', false, { root: true });

      dispatch('fetchCotacoes', { page: 1, perPage: 20 });
    } catch (e) {
      console.error(e);

      dispatch('toggleLoading', false, { root: true });

      if (e instanceof AxiosError) {
        return e;
      }

      return e.inner;
    }
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
  limparCotacao({ commit }) {
    commit('SET_COTACAO', { produtos: [] });
  },
  async setarValoresPadrao({ rootGetters }, cotacao) {
    const { moeda } = cotacao.produtos[0];

    // sintáxe estranha, mas é assim que passa argumento pra um getter que aceita parametro através do rootGetters 👌
    cotacao.taxaMoeda = rootGetters['cotacao/getValorCotacao'](moeda).toFixed(2);
    cotacao.honorarioDespacho = rootGetters['simulacao/getSalarioMinimo'].toFixed(2);
    cotacao.despesasAdministrativas = rootGetters['simulacao/getValorBaseDespesasAdministrativas'].toFixed(2);
    cotacao.seguroInternacional = '0,30';

    if (cotacao.incoterm !== 'EXW') {
      cotacao.custosOrigem = 0;
    }

    return cotacao;
  },
  async importarDadosProdutosTemplate(_, templateExcel) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(templateExcel);

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = rows.shift();

        const headerMap = {
          'Nome Produto': 'nomeProduto',
          'VALOR UNI.': 'valorUnitario',
          'QTD.': 'quantidade',
          'MEDIDA': 'unidadeMedida',
          'NCM': 'ncm',
          'L.I': 'li',
          'II': 'ii',
          'IPI': 'ipi',
          'PIS': 'pis',
          'COFINS': 'cofins',
          'COFINS CUSTO': 'cofinsCusto',
          'ICMS (LETRA)': 'icms',
          'PIS SAÍDA': 'pisSaida',
          'COFINS SAÍDA': 'cofinsSaida',
          'MARKUP': 'markup',
          'DESCONTO': 'desconto',
          'DRE ITEM': 'dreItem',
          'Peso Líquido': 'pesoLiquido',
          'Unit. Bruto': 'unitBruto',
          'Unit. Liquido': 'unitLiquido',
        };

        const camposPorcentagem = [
          'II',
          'IPI',
          'PIS',
          'COFINS',
          'COFINS CUSTO',
          'PIS SAÍDA',
          'COFINS SAÍDA',
          'MARKUP',
          'DESCONTO',
          'DRE ITEM',
        ];

        const filteredRows = rows.filter((row) => row.some((cell) => cell !== undefined && cell !== ''));

        const produtos = filteredRows.map((row) => {
          const produto = {};

          headers.forEach((header, index) => {
            const key = headerMap[header];
            const isCampoPorcentagem = camposPorcentagem.includes(header);

            if (key) {
              let value = row[index];

              if (isCampoPorcentagem) {
                value = value ? parseFloat(value) * 100 : 0;
                produto[key] = value !== 0 ? parseFloat(value.toFixed(2)) : 0;
              } else {
                produto[key] = value;
              }
            }

            produto.moeda = 'USD';
          });

          return produto;
        });

        resolve(produtos);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  },
  async fetchCabecalhosInvoice({ commit }) {
    const response = await api.get('/processo/invoice/cabecalho-invoice');

    commit('SET_INVOICES', response.data);
  },
  async fetchItensInvoice(_, codigoInvoice) {
    const response = await api.get(`/processo/invoice/${codigoInvoice}/itens-invoice`);

    return response.data;
  },
};
